<template>
  <div class="min-h-screen flex items-center justify-center bg-white">
    <p class="text-gray-500 text-sm">Auth failed</p>
  </div>
</template>

<script setup lang="ts">
// No logic needed; purely presentational
</script> 